import { useState, useEffect } from 'react';
import styled from 'styled-components';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { useSnackbar } from 'notistack';
import { round } from 'lodash';
import { useTranslation } from 'react-i18next';
import { getHighscores } from '../../services/Highscores';
import { kassimGreen, makeTransparent } from '../../style/theme';
import { useAuthContext } from '../../contexts/AuthContext';

const StyledTableRow = styled(TableRow)`
    &:nth-child(odd) {
        background-color: ${({ $currentUser }) =>
            $currentUser ? '#FFFF0090' : '#00000020'};
    }

    ${({ $currentUser }) =>
        $currentUser &&
        `background: #FFFF0090; & .MuiTableCell-root {font-weight: bold; }`}
`;

const StyledTableCell = styled(TableCell)`
    border-bottom: ${({ $head }) => ($head ? `1px solid #00000085` : `none`)};
    text-align: ${({ $align }) => $align};
    ${({ $cellStyle }) => $cellStyle}
`;

const Highscores = ({ gameToken }) => {
    const [highscores, setHighscores] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { auth } = useAuthContext();
    const { username } = auth;

    useEffect(() => {
        let mounted = true;
        if (gameToken)
            getHighscores(gameToken)
                .then((highscoreData) => {
                    if (!mounted) return;
                    const userScores = Object.entries(highscoreData).map(
                        ([key, value]) => ({ ...value, name: key })
                    );
                    setHighscores(userScores);
                })
                .catch((err) => {
                    console.warn(t('error.loadHighscores'), err.message);
                    // enqueueSnackbar(
                    //     <div>
                    //         <p>{t('error.loadHighscores')}</p>
                    //         <p>{err.message}</p>
                    //     </div>,
                    //     {
                    //         variant: 'error',
                    //     }
                    // );
                });
        return () => {
            mounted = false;
        };
    }, [gameToken, enqueueSnackbar, t]);

    const columns = [
        { key: 'name', label: t('Player') },
        { key: 'progress', label: t('highscores.progress'), align: 'right' },
        {
            key: 'points',
            label: t('highscores.points'),
            format: (d) => round(d),
            align: 'right',
            cellStyle: `background: ${makeTransparent(kassimGreen, 0.3)}`,
        },
        {
            key: 'prod',
            label: t('highscores.prod'),
            format: (d) => round(d, 1),
            align: 'right',
        },
        {
            key: 'prof',
            label: t('highscores.prof'),
            format: (d) => round(d, 2),
            align: 'right',
        },
        {
            key: 'eff',
            label: t('highscores.eff'),
            format: (d) => round(d, 1),
            align: 'right',
        },
        { key: 'usage', label: t('highscores.usage'), align: 'right' },
    ];
    return (
        <TableContainer style={{ maxWidth: '100%' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        {columns.map((col) => {
                            return (
                                <StyledTableCell
                                    key={col.key}
                                    $align={col.align || 'left'}
                                    $cellStyle={col.cellStyle}
                                    $head
                                >
                                    {col.label}
                                </StyledTableCell>
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {highscores.map((userScore) => (
                        <StyledTableRow
                            key={userScore.name}
                            $currentUser={username === userScore.name}
                        >
                            {columns.map((col) => {
                                return (
                                    <StyledTableCell
                                        key={`${userScore.name}-${col.key}`}
                                        $align={col.align || 'left'}
                                        $cellStyle={col.cellStyle}
                                    >
                                        {col.format
                                            ? col.format(userScore[col.key])
                                            : userScore[col.key]}
                                    </StyledTableCell>
                                );
                            })}
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default Highscores;
